import { render, staticRenderFns } from "./DetalhesPlantaFabril.vue?vue&type=template&id=51038c89&scoped=true&lang=pug"
import script from "./DetalhesPlantaFabril.vue?vue&type=script&lang=js"
export * from "./DetalhesPlantaFabril.vue?vue&type=script&lang=js"
import style0 from "./DetalhesPlantaFabril.vue?vue&type=style&index=0&id=51038c89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51038c89",
  null
  
)

export default component.exports